import styled from 'styled-components';

import { layout } from '../../../package.json';
import { config } from '../../config';

export const Root = styled.div`
  width: 100%;
  height: 80px;
  padding: 0 2%;

  background-color: ${config.color.background};
  color: #e2e2e2;
`;

export const Container = styled.div`
  max-width: 1400px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content-center;
  margin: auto;
`;

export const ContainerLogo = styled.div`
  height: 75px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  margin-right: 32px;

  img {
    min-width: 160px;
    max-width: 240px;
    height: auto;
    max-height: 120px;
    display: block;
  }

  @media (max-width: ${layout.tablet}) {
    display: none;
  }
`;

export const ContainerInputBox = styled.div`
  display: flex;
  margin: auto;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index:999;
  
  height: 100%;
  max-height: 50px;

  > div {
    width: 100%;
  }

  input {
    width: 100%;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #ccc;
  }
`;

export const ContainerInput = styled.div`
  width: 100%;
  height: 75px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: ${layout.desktop_wide}) {
    width: 100%;
  }
`;

export const ContainerInputResult = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: 100%;
  margin-top: 200px;

  background: #f2f2f2;

  border: 1px solid var(--primary);
  border-top: none;
  border-radius: 10px;
  border-top-left-radius: unset;
  border-top-right-radius: unset;

  @media (max-width: ${layout.desktop_wide}) {
    width: 100%;
  }
`;

export const ContainerInputResultItem = styled.div`
  display: grid;

  align-items: center;
  justify-content: flex-start;

   grid-template-areas:
     'imagem title title'
     'imagem category price';

  width: 95%;
  height: 80px;
  margin-top: 6px;
  padding: 8px;
  margin-left: 2%;

  color: var(--fontcolor);
  background: var(--white);

  :hover {
    background-color: #da60213d;
    border-radius: 8px;
  }

  :last-child {
    margin-bottom: 10px;
  }

  cursor: pointer;

  //@media (max-width: ${layout.mobile}) {
    // //grid-template-areas:
    // 'title title title'
    // 'price price price';

  //}
`;

export const ContainerInputResultItemImage = styled.div`
  grid-area: imagem;

  display: flex;
  align-items: center;

  width: 60px;
  height: 60px;
  margin: 0 8px;

  img {
    width: 50px;
    height: 50px;
  }
`;

export const ContainerInputResultItemTitle = styled.div`
  grid-area: title;

  display: flex;

  height: 30px;

`;

export const ContainerInputResultItemPrice = styled.div`
  grid-area: price;

  display: flex;
  justify-content: center;

  height: 30px;

  //@media (max-width: ${layout.mobile}) {
    justify-content: flex-start;
  //}
`;

export const ContainerInputResultItemCategory = styled.div`
  grid-area: category;

  display: flex;
  justify-content: flex-start;

  height: 30px;
  color: var(--primary);
`;

export const ContainerInputResultItemActions = styled.div`
  grid-area: button;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 40px;
  border: 1px solid green;
  background: green;
  border-radius: 10px;
  margin-top: 10px;

  cursor: pointer;

  span {
    border-radius: 5px;
    color: var(--white);
  }

  svg {
    margin-right: 10px;
  }
  display:none;
`;
// export const MenuItem = styled.span`
//   width: 110px;
//   height: 30px;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   margin-left: 10px;
//   color: #646464;
//   border-left: 1px solid #fffff0;
//   font-size: 16px;
//   font-weight: 400;

//   @media (max-width: ${layout.mobile}) {
//     svg {
//       margin-right: 16px;
//     }
//   }

//   :hover {
//     color: var(--primary);
//     cursor: pointer;
//   }
// `;

// export const ContainerMobile = styled.div`
//   width: 100%;
//   height: 67px;
//   z-index:1000;

//   display: none;
//   align-items: center;
//   justify-content: space-evenly;
//   position: fixed;

//   border-top: 1px solid var(--primary);
//   bottom: 0;
//   left: 0;
//   background-color: ${color.background};

//   @media (max-width: ${layout.mobile}) {
//     display: flex;

//     a {
//       text-decoration: none;
//     }
//   }
// `;

